import { render, staticRenderFns } from "./certificateEdit.vue?vue&type=template&id=7ce8c490&"
import script from "./certificateEdit.vue?vue&type=script&lang=js&"
export * from "./certificateEdit.vue?vue&type=script&lang=js&"
import style0 from "./certificateEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports